// src/modules/fcm/reducers.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { setFcmToken } from './actions';

interface FcmState {
  isLoading: boolean;
  error: string | null;
  success: boolean;
  messages: any[]; // unstructured format as requested
}

const initialState: FcmState = {
  isLoading: false,
  error: null,
  success: false,
  messages: [],
};

export const fcmSlice = createSlice({
  name: 'fcm',
  initialState,
  reducers: {
    addFcmMessage: (state, action: PayloadAction<any>) => {
      state.messages.push(action.payload);
    },
    clearFcmMessages: (state) => {
      state.messages = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setFcmToken.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(setFcmToken.fulfilled, (state) => {
        state.isLoading = false;
        state.success = true;
      })
      .addCase(setFcmToken.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { addFcmMessage, clearFcmMessages } = fcmSlice.actions;

export default fcmSlice.reducer;
